export const GRID_ITEM_CONF = {
  size: {
    xs: 12,
    sm: 6,
  },
}

export const FM_ROOT = 'pages.campaigns.detail.fields.'
